// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"51":"locale-sc-json","64":"locale-tc-json","990":"locale-en-json"}[chunkId] + "." + {"51":"b8f88111","64":"bfd02386","990":"67ce7c70"}[chunkId] + ".js";
};